import { memo, useCallback, useContext } from "react"
import { FilesUploadContext } from "./FilesUpload"
import Button, { ButtonProps } from "../button/Button"

interface FilesUploadButtonV2Props extends ButtonProps {
  children?: React.ReactNode
  className?: string
}

export const FilesUploadButtonV2 = (props: FilesUploadButtonV2Props) => {
  const { children, ...rest } = props

  const { filesRef } = useContext(FilesUploadContext)

  const handleClick = useCallback(() => {
    if (filesRef.current) {
      filesRef.current.click()
      filesRef.current.value = ""
    }
  }, [filesRef.current])

  return (
    <Button onClick={handleClick} {...rest}>
      {children}
    </Button>
  )
}

export default memo(FilesUploadButtonV2)
